interface ValorDaReferencia {
  horas_valor_hora?: number | string | null;
}

type Resposta = { data: ValorDaReferencia[] };

type BuscaDeValor = (referenceId: number) => Promise<Resposta>;

/**
 * Devolve uma busca do valor da hora que consulta a API uma única vez por
 * referência. As telas de horas pediam o valor a cada linha; com algumas
 * centenas de linhas isso estourava o limite de requisições do servidor
 * e os totais nunca chegavam. A promessa fica guardada, então linhas
 * concorrentes da mesma referência dividem a mesma requisição.
 */
export const criarBuscaDeValorHora = (buscar: BuscaDeValor): BuscaDeValor => {
  const porReferencia = new Map<number, Promise<Resposta>>();

  return (referenceId: number) => {
    const emAndamento = porReferencia.get(referenceId);
    if (emAndamento) return emAndamento;

    const nova = buscar(referenceId).catch((erro) => {
      porReferencia.delete(referenceId);
      throw erro;
    });
    porReferencia.set(referenceId, nova);
    return nova;
  };
};
